// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"60":"95cc8b295e8c2fe2","1069":"58387ad1b8265040","2888":"41176555bec6f896","5078":"01cd20ddfaa5a7a3","6663":"95cc8b295e8c2fe2","7695":"58387ad1b8265040"}[chunkId] + ".css";
};